var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseModalContent',{attrs:{"name":"yandex-modal","dynamic":true},on:{"close":function($event){return _vm.$emit('close')}}},[_c('BindYandex',{on:{"done":function($event){return _vm.$emit('close')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }